import React, { useState } from "react";
import { InputBoxWraper } from "../../constents/components";
import passwordIcon from "../../Assets/svgs/passwordIcon.svg";
import opendEyeIcon from "../../Assets/svgs/opendEyeIcon.svg";
import closedEyeIcon from "../../Assets/svgs/closedEyeIcon.svg";

const Password = ({
  setPasswordError,
  setPassword,
  password,
  placeholder = "Password",
}) => {
  const [isPasswordVisible, setPasswordVisible] = useState(false);

  return (
    <InputBoxWraper icon={passwordIcon} iconAltText="passwordIcon">
      <input
        className="outline-none border-none flex-1"
        type={isPasswordVisible ? "text" : "password"}
        placeholder={placeholder}
        value={password}
        onChange={(e) => {
          setPassword(e.target.value);
        }}
      />

      <img
        className="cursor-pointer"
        src={isPasswordVisible ? opendEyeIcon : closedEyeIcon}
        alt="passwordIconType"
        onClick={() => setPasswordVisible((pre) => !pre)}
      />
    </InputBoxWraper>
  );
};

export default Password;
